document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove = document.querySelector(".tee-product-price");
  const insertAfterElement = document.querySelector(".product__policies");
  if (elementToMove && insertAfterElement) {
    insertAfterElement.before(elementToMove);
  }

  const elementToMove1 = document.querySelector(".tee-available-products");
  const insertAfterElement1 = document.querySelector(
    ".tee-customize-main-form"
  );
  if (elementToMove1 && insertAfterElement1) {
    insertAfterElement1.after(elementToMove1);
  }
});
